export default {"src":"/_next/static/media/waicon.4d5e9d5f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};